$(document).ready(function() {
    $('.validation_message').text('Error')

    // Iterate over input fields
    $('.gform-body input').each(function() {
        var $input = $(this);

        $input.on('focus', function() {
            if ($input.val().length == 0) {
                $input.closest('.gfield').addClass('active');
            }
        });

        $input.on('blur', function() {
            if ($input.val().length == 0) {
                $input.closest('.gfield').removeClass('active');
            }
        });

        // Check for non-empty value on page load
        if ($input.val() != '') {
            $input.closest('.gfield').addClass('active');
        }
    });

    $('.gfield_error input').each(function() {
        var $input = $(this);
        // console.log($input);
        $input.on('focus',function(){
            $(this).closest('.gfield_error').find('.validation_message').text('');
        });
        $input.on('blur',function(){
            if ($(this).val().trim() === '') {
                $(this).closest('.gfield_error').find('.validation_message').text('Error');
            }
        });

    });


    // Find all elements with class .textarea
    $('.ginput_container_text,.ginput_container_email,.ginput_container_phone').each(function() {
        // Find the closest sibling with class .gfield_label and add a class to it
        $(this).closest('.gfield').find('.gfield_label').addClass('input-label');
    });


    // Find all elements with class .textarea
    $('.textarea,.ginput_container_date,.ginput_container_website,.ginput_container_fileupload,.ginput_container_radio,.ginput_container_checkbox').each(function() {
        // Find the closest sibling with class .gfield_label and add a class to it
        $(this).closest('.gfield').find('.gfield_label').addClass('textarea-label');
    });

    if ($('.gform_wrapper').length) {
        // Check if the confirmation wrapper exists
        var disclaimer = '<p class="disclaimer">We respect your <a href="/privacy-policy/">privacy</a>.</p>';
        $('.form.bg-blue').append(disclaimer);
    }


});